import * as React from "react";

const Tooltip = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.094 17.052C13.206 17.0613 13.262 17.1267 13.262 17.248C13.262 17.3693 13.192 17.43 13.052 17.43L11.722 17.374L10.21 17.43C10.07 17.43 10 17.3693 10 17.248C10 17.1267 10.056 17.0613 10.168 17.052L10.56 17.024C10.7467 17.0053 10.9007 16.9493 11.022 16.856C11.1433 16.7533 11.204 16.618 11.204 16.45V11.326C11.204 11.1393 11.162 11.0133 11.078 10.948C11.0033 10.8733 10.8773 10.836 10.7 10.836H10.224C10.1027 10.836 10.042 10.7753 10.042 10.654C10.042 10.5327 10.1027 10.4627 10.224 10.444L12.044 10.22C12.212 10.2013 12.296 10.3087 12.296 10.542V16.45C12.296 16.786 12.4827 16.9773 12.856 17.024L13.094 17.052ZM11.148 8.106C11.0267 7.98467 10.966 7.83067 10.966 7.644C10.966 7.45733 11.0267 7.30333 11.148 7.182C11.2787 7.06067 11.4373 7 11.624 7C11.8107 7 11.9693 7.06067 12.1 7.182C12.2307 7.30333 12.296 7.45733 12.296 7.644C12.296 7.83067 12.2307 7.98467 12.1 8.106C11.9693 8.22733 11.8107 8.288 11.624 8.288C11.4373 8.288 11.2787 8.22733 11.148 8.106Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
    <circle cx="12" cy="12" r="9" stroke="white" />
  </svg>
);

export default Tooltip;
